<template>
  <t-text-input
    v-model="password"
    :type="showPassword ? 'text' : 'password'"
    v-bind="$attrs"
    :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
    @click:append="showPassword = !showPassword"
  />
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import TTextInput from "@/components/core/TTextInput.vue";

interface Props {
  show?: boolean;
  modelValue?: string;
}

const {
  show = undefined,
  modelValue = "",
} = defineProps<Props>();

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

defineOptions({
  name: "TPasswordInput",
  inheritAttrs: false,
});

const localShow = ref<boolean>(false);

const password = computed<string>({
  get(): string {
    return modelValue;
  },
  set(password: string) {
    emit("update:modelValue", password);
  },
});

const showPassword = computed<boolean>({
  get(): boolean {
    return show ?? localShow.value;
  },
  set(status: boolean) {
    if (show === undefined) localShow.value = status;
  },
});
</script>
